export default {
	add_to_your_calendar: "Add to your calendar",
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files: "Explore our universe of courses, videos, articles and exclusive files.",
	home_drills_title: "Drills",
	home_events_title: "My Events",
	home_keep_watching_title: "Keep watching",
	home_library_title: "Library",
	home_live_classes_title: "Live Classes",
	home_news_title: "News",
	home_online_courses_title: "Online Courses",
	home_podcasts_title: "Podcasts",
	home_surveys_title: "Surveys",
	home_tags_title: "Highlights",
	home_trails_title: "Trails",
	home_webinars_title: "Webinars",
	no_events_available_for_the_selected_date: "No events available.",
	welcome_to: "Welcome to",
	what_do_you_want_to_learn_today: "What do you want to learn today?"
}